module.exports = __webpack_public_path__ + "assets/overview-folder.88085e93.svg";